import {  Button,  Dialog, DialogContent, DialogActions,   IconButton, Typography, Box, DialogTitle, SvgIcon, Grid, Tooltip, Stack } from '@mui/material';
import {  Trash01 } from '../../../../assets';
import { theme } from '../../../../theme';
import CloseIcon from '@mui/icons-material/Close';
import { TrainingMaterialContext, TrainingMaterialValues } from '../../contexts/TrainingMaterialContext';
import { useContext, useEffect } from 'react';
import {  UploadFile } from '@mui/icons-material';


const CreateModal=() => {
  const { t,
    previewOpen,
    selectedFiles, isModalOpen, handleClose,  handleSaveAllFiles,setPreviewOpen, handleFileSelection, removeFileFromPreview, setSelectedFiles } = useContext(TrainingMaterialContext) as TrainingMaterialValues;
  
  useEffect(() => {
    if (isModalOpen) {
      setSelectedFiles([]);
      setPreviewOpen(false);
    }
  }, [isModalOpen]);
  
  return (
    <Dialog
      maxWidth='sm'
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <UploadFile />
        <Typography variant="textLG"
          sx={{ ml: '5px' }}>
          {t('create')}
        </Typography>
        <IconButton
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.custom.gray[800],
            mr: '-10px',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent>
        <Box >
          <input
            type="file"
            id="multiple-file-upload"
            hidden
            multiple
            accept=".pdf, .jpg, .jpeg,.png"
            onChange={handleFileSelection}
          />

          <Button
            variant="primary"
            onClick={() => document.getElementById('multiple-file-upload')?.click()}
            startIcon={<UploadFile />}
          >
            {t('selectFiles')}
          </Button>
  
          <Tooltip 
            title="Supported file types:PDF, JPG, JPEG, PNG. Maximum size: 2MB. If the file is over 2MB please compress it prior to upload."
            placement="right"
            arrow
          >
            <IconButton size="small"
              sx={{ ml: 1 }}>
              <SvgIcon fontSize="small">
                <svg xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 110 20 10 10 0 010-20z" />
                </svg>
              </SvgIcon>
            </IconButton>
          </Tooltip>

          {previewOpen && selectedFiles.length > 0 && (
            <Box
              sx={{
                mt: 3,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                backgroundColor: '#fff',
                boxShadow: 1,
              }}
            >
             
              <Box sx={{ 
                maxHeight: '250px',  
                overflow: 'auto',    
                pr: 1,               
              }}>
                <Grid container
                  spacing={2}>
                  {selectedFiles.map((file, index) => (
                    <Grid item
                      xs={12}
                      key={index}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          p: 1,
                          borderBottom: '1px solid #f0f0f0',
                        }}
                      >
                        <Typography>{file.name}</Typography>
                        <Typography  color="textSecondary">
                          {(file.size / 1024).toFixed(2)} KB
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => removeFileFromPreview(index)}
                          sx={{ color: theme.palette.error[500] }}
                        >
                          <Trash01 />
                        </IconButton>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Box>
          )} 
        </Box>
      </DialogContent>
      <DialogActions sx={{ 
        padding: '0px 24px 24px', 
        '&.MuiDialogActions-root': {
          padding: '0px 24px 24px', 
        },
      }}>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='12px'
          width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            sx={{ fontSize: '16px' }} 
            onClick={handleClose}>
            {t('cancel')}
          </Button>
          <Button
            fullWidth
            sx={{ fontSize: '16px' }} 
            variant="primary"
            size="md"
            disabled={selectedFiles.length === 0}
            onClick={handleSaveAllFiles} 
          >
            {t('save')} 
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>

  );
};

export default CreateModal;

